import { motion } from "framer-motion";
import { StatusIndicator } from "./StatusIndicator";

export const Navbar = () => (
    <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06] bg-black/60 backdrop-blur-xl"
    >
        <nav
            data-testid="main-nav"
            className="mx-auto flex max-w-7xl items-center justify-between px-6 py-1 lg:px-10"
            aria-label="Navigasi utama"
        >
            <a href="/" data-testid="nav-logo" className="flex items-center">
                <img
                    src="/logo.png"
                    alt="Logo PUSATCUAN - Layanan Bantuan WhatsApp & Telegram 24 Jam"
                    width="160"
                    height="80"
                    loading="eager"
                    className="h-20 w-auto drop-shadow-[0_0_16px_rgba(212,175,55,0.45)]"
                />
            </a>
            <StatusIndicator className="hidden sm:inline-flex" />
        </nav>
    </motion.header>
);
